import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './style.module.css';

const CustomSelectEx = ({
  title,
  placeholder,
  value,
  onChange,
  options,
  multi = false,
  AddOption = false,
  onCreateOption,
  Err = 'Incorrect Container number',
  width,
  minWidth,
  required,
  onCreateOptionContainer,
  font = false,
  dropdown = false,
  height = false,
  maxHeight = false,
  id,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState('');
  const [justAddedCustom, setJustAddedCustom] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const [tempValue, setTempValue] = useState('');

  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);
  useEffect(() => {
    if (!multi && searchTerm?.length === 11) {
      setError('');
      if (onCreateOptionContainer) {
        onCreateOptionContainer(displayValue());
        setIsOpen(false);
      }
    }
  }, [searchTerm]);
  const commitOption = (opt) => {
    const valObj = {
      label: opt?.label ? opt.label : opt,
      value: opt?.value ? opt.value : opt,
    };
    const next = multi
      ? [...(Array?.isArray(value) ? value : []), valObj]
      : valObj;

    onChange(next);
    AddOption && onCreateOption(opt?.label || opt);
    setJustAddedCustom(true);
    setSearchTerm('');
    !multi && setError('');
    setIsOpen(false);
  };

  // Custom outside click handler that excludes dropdown options
  useEffect(() => {
    function handleClickOutside(event) {
      // Check if click is outside wrapper and not on dropdown options
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        if (AddOption && multi && searchTerm?.trim()) {
          commitOption(searchTerm?.trim());
        }

        // Restore previous value if no new selection was made
        if (!multi && tempValue && !searchTerm) {
          setSearchTerm(tempValue);
          setTempValue('');
        }

        setIsOpen(false);
        if (
          AddOption &&
          multi === false &&
          searchTerm &&
          searchTerm?.length < 11
        ) {
          setError(Err);
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [AddOption, multi, searchTerm, Err, tempValue]);

  useEffect(() => {
    if (!multi && typeof value === 'object') {
      if (justAddedCustom) {
        setJustAddedCustom(false);
      } else {
        setSearchTerm(value?.label || '');
        onCreateOption && value?.label?.length < 11 && setError(Err);
      }
      !value?.label && setError('');
    }
  }, [value]);

  const selectedValues = multi
    ? Array?.isArray(value)
      ? value
      : []
    : value
    ? [value]
    : [];

  const isSelected = (opt) =>
    selectedValues?.some((v) => v?.value === opt?.value);

  const handleOptionClick = (opt) => {
    if (multi) {
      commitOption(opt);
    } else {
      onChange(opt);
      AddOption ? setSearchTerm(opt?.label) : setSearchTerm('');
      setIsOpen(false);
    }
  };

  const handleInputChange = (e) => {
    let full = e?.target?.value;
    const prefix = selectedValues?.length
      ? selectedValues?.map((v) => v?.label)?.join(', ') + ', '
      : '';
    let newTerm = full?.startsWith(prefix) ? full?.slice(prefix?.length) : full;
    const clean = multi
      ? newTerm?.replace(/[^a-zA-Z0-9 ,]/g, '')
      : newTerm?.replace(/[^a-zA-Z0-9 ]/g, '');

    if (multi) {
      if (clean?.length <= 11) {
        setSearchTerm(clean);
        setError('');
      }
    } else {
      if (clean?.length <= 11) {
        setSearchTerm(clean);
        setError('');
        value?.label?.length === 11 &&
          onCreateOptionContainer &&
          onCreateOptionContainer(clean);

        // if (clean.length <= 11) {
        //   setError(Err);
        //   onChange && onChange(null);
        // } else if (clean.length === 11) {
        //   setError('');
        //   onChange && onChange({ label: clean, value: clean });
        // }
      }
    }

    const newFiltered = options?.filter((opt) =>
      opt?.label?.toLowerCase()?.includes(clean?.toLowerCase())
    );
    if (multi && newFiltered?.length === 0 && clean?.length > 1) {
      setIsOpen(false);
      return;
    }
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter' || e?.key === ',') {
      e.preventDefault();
      if (multi && searchTerm?.trim()) {
        const trimmed = searchTerm?.trim();
        if (trimmed?.length === 11) {
          commitOption(trimmed);
        } else {
          setError(Err);
        }
      } else {
        setIsOpen(false);
        if (inputRef?.current) inputRef.current.blur();
      }
    } else if (e?.key === 'Backspace' && multi) {
      const lastCommaIndex = searchTerm?.lastIndexOf(',');
      if (lastCommaIndex !== -1) {
        setSearchTerm(searchTerm?.slice(0, lastCommaIndex));
      } else {
        setSearchTerm(searchTerm?.slice(0, -1));
      }
    }
  };

  const displayValue = () => {
    if (!multi) return searchTerm;
    const prefix = selectedValues?.length
      ? selectedValues?.map((v) => v?.label)?.join(', ') + ', '
      : '';
    return prefix + searchTerm;
  };

  const filteredOptions = (
    searchTerm
      ? options?.filter((opt) =>
          opt?.label?.toLowerCase()?.includes(searchTerm?.toLowerCase())
        )
      : options
  )?.filter((opt) => opt?.value !== '' && opt?.value !== undefined);

  const handleBlur = () => {
    if (!onCreateOption && filteredOptions?.length === 0) {
      setInputValue('');
    }
    if (
      !multi &&
      AddOption &&
      searchTerm?.length > 0 &&
      searchTerm?.length < 11
    ) {
      setError(Err);
    }

    if (
      multi &&
      searchTerm?.length > 0 &&
      searchTerm?.length < 11 &&
      AddOption
    ) {
      setError(Err);
    }
    if (onCreateOptionContainer && filteredOptions?.length === 0) {
      onCreateOptionContainer(displayValue());
      setIsOpen(false);
    }
  };

  const handleFocus = () => {
    setError('');
    if (!multi && !onCreateOption && filteredOptions?.length === 0) {
      setSearchTerm('');
    }
  };

  useEffect(() => {
    if (!isOpen) return;

    const handleResize = () => setIsOpen(false);
    const updateDropdownPos = () => {
      if (wrapperRef.current) {
        const wrapperRect = wrapperRef.current.getBoundingClientRect();
        setDropdownPos({
          top: wrapperRect.bottom + window.scrollY,
          left: wrapperRect.left + window.scrollX,
          width: wrapperRect.width,
        });

        if (wrapperRect.bottom < 64) {
          setIsOpen(false);
        }
      }
    };

    // Update position immediately when dropdown opens
    updateDropdownPos();

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', updateDropdownPos, true);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', updateDropdownPos, true);
    };
  }, [isOpen]);

  const renderDropdown = () => {
    if (!isOpen || (!multi && AddOption && !filteredOptions?.length))
      return null;

    return createPortal(
      <div
        id="dropdown-container"
        ref={dropdownRef}
        className={`${styles.options} ${
          filteredOptions?.length > 6 ? styles.scrollOptions : ''
        }`}
        style={{
          position: 'absolute',
          top: dropdownPos.top + 5,
          left: dropdownPos.left,
          width: Math.max(dropdownPos.width, minWidth || 0),
        }}>
        {filteredOptions?.map((opt) => (
          <div
            key={opt?.value}
            className={`${styles.option} ${
              isSelected(opt) ? styles.selected : ''
            }`}
            onClick={() => {
              handleOptionClick(opt);
            }}>
            {['NONE', 'HIGH', 'MEDIUM', 'LOW', 'EXCLUDE'].includes(
              opt?.value
            ) && (
              <span
                className={
                  styles.priorityCircle +
                  ' ' +
                  (opt.value === 'NONE'
                    ? styles['priority-none']
                    : opt.value === 'HIGH'
                    ? styles['priority-high']
                    : opt.value === 'MEDIUM'
                    ? styles['priority-medium']
                    : opt.value === 'LOW'
                    ? styles['priority-low']
                    : opt.value === 'EXCLUDE'
                    ? styles['priority-exclude']
                    : '')
                }></span>
            )}
            {opt?.label}
          </div>
        ))}
      </div>,
      document.body
    );
  };
  return dropdown ? (
    <>
      <div
        className={styles.wrapper}
        ref={wrapperRef}
        style={{ width: width }}
        id={id}>
        {title && (
          <span className={font ? styles.biglabel : styles.label}>
            {title}
            {required && <span className={styles.requiredField}>*</span>}
            {required && <span className={styles.requiredText}>Required</span>}
          </span>
        )}

        <div
          className={`${font ? styles.selectBoxFont : styles.selectBox} ${
            isOpen ? styles.focused : ''
          } ${error ? styles.error : ''}`}
          style={{ height: height, maxHeight: maxHeight }}
          onClick={(e) => {
            if (!isOpen) {
              // Opening dropdown - always store current value in temp and clear input
              if (!multi) {
                const currentValue = searchTerm || value?.label || '';
                if (currentValue) {
                  setTempValue(currentValue);
                  setSearchTerm('');
                }
              }
            } else {
              // Closing dropdown without selection - restore previous value
              if (!multi && tempValue && !searchTerm) {
                setSearchTerm(tempValue);
                setTempValue('');
              }
            }

            if (!isOpen && wrapperRef.current) {
              const wrapperRect = wrapperRef.current.getBoundingClientRect();
              setDropdownPos({
                top: wrapperRect.bottom + window.scrollY,
                left: wrapperRect.left + window.scrollX,
                width: wrapperRect.width,
              });
            }
            setIsOpen(!isOpen);
          }}>
          <input
            ref={inputRef}
            type="text"
            className={font ? styles.bigInput : styles.input}
            placeholder={!displayValue()?.length ? placeholder : ''}
            value={displayValue()}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
          {filteredOptions?.length > 0 && (
            <span className={styles.arrow}></span>
          )}
        </div>

        {error && <div className={styles.errorMessage}>{error}</div>}
      </div>

      {renderDropdown()}
    </>
  ) : (
    <div
      className={styles.wrapper}
      ref={wrapperRef}
      style={{ width: width }}
      id={id}>
      {title && (
        <span className={font ? styles.biglabel : styles.label}>
          {title}
          {required && <span className={styles.requiredField}>*</span>}
          {required && <span className={styles.requiredText}>Required</span>}
        </span>
      )}

      <div
        className={`${styles.selectBox} ${isOpen ? styles.focused : ''} ${
          error ? styles.error : ''
        }`}
        style={{ height: height, maxHeight: maxHeight }}
        onClick={() => {
          if (!isOpen) {
            // Opening dropdown - always store current value in temp and clear input
            if (!multi) {
              const currentValue = searchTerm || value?.label || '';
              if (currentValue) {
                setTempValue(currentValue);
                setSearchTerm('');
              }
            }
          } else {
            // Closing dropdown without selection - restore previous value
            if (!multi && tempValue && !searchTerm) {
              setSearchTerm(tempValue);
              setTempValue('');
            }
          }

          setIsOpen(!isOpen);
        }}>
        <input
          ref={inputRef}
          type="text"
          className={font ? styles.bigInput : styles.input}
          placeholder={!displayValue()?.length ? placeholder : ''}
          value={displayValue()}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
        {filteredOptions?.length > 0 && <span className={styles.arrow}></span>}
      </div>

      {error && <div className={styles.errorMessage}>{error}</div>}

      {isOpen && !(!multi && AddOption && !filteredOptions?.length) && (
        <div
          className={`${styles.options} ${
            filteredOptions?.length > 6 ? styles.scrollOptions : ''
          }`}
          style={{
            position: 'absolute',
            width: '100%',
            minWidth: minWidth,
          }}>
          {filteredOptions?.length ? (
            filteredOptions?.map((opt) => (
              <div
                key={opt?.value}
                className={`${styles.option} ${
                  isSelected(opt) ? styles.selected : ''
                }`}
                onClick={() => handleOptionClick(opt)}>
                {['NONE', 'HIGH', 'MEDIUM', 'LOW', 'EXCLUDE'].includes(
                  opt?.value
                ) && (
                  <span
                    className={
                      styles.priorityCircle +
                      ' ' +
                      (opt.value === 'NONE'
                        ? styles['priority-none']
                        : opt.value === 'HIGH'
                        ? styles['priority-high']
                        : opt.value === 'MEDIUM'
                        ? styles['priority-medium']
                        : opt.value === 'LOW'
                        ? styles['priority-low']
                        : opt.value === 'EXCLUDE'
                        ? styles['priority-exclude']
                        : '')
                    }></span>
                )}
                {opt?.label}
              </div>
            ))
          ) : (
            <div className={styles.option} style={{ color: '#999' }}>
              No options found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomSelectEx;
